import React, {useEffect, useState} from 'react';
import {useRpcSender} from "../../../../util/RpcSender";
import {GetClientListResponse, IClientProto} from "../../../../provider_api";
import {RpcState} from "../../../../util/RpcState";
import {KensuTable} from "../../../../components/table/KensuTable";
import {TabbedPageHeader} from "../../../../components/TabbedPageHeader";
import {shortDateFormat} from "../../../../util/DateTimeUtils";

import {useNavigateWithParams} from "../../../../util/NavUtils";
import {useClientsTab} from "./ClientsRouter";
import {fullName} from "../../../../util/BookingUtil";

export const ClientList = () => {

  const rpcSender = useRpcSender();
  const navigate = useNavigateWithParams();

  const [rpcState, setRpcState] = useState<RpcState>({state: "pending"});

  const [clients, setClients] = useState<IClientProto[]>();

  useEffect(() => {

    rpcSender.send('get_client_list', new Uint8Array([]))
        .then(r => {
          const response = GetClientListResponse.decode(r);
          if (!response.okay) {
            setRpcState({state: 'error', message: 'unknown error fetching login'});
            return;
          }

          setClients(response.client);
          setRpcState({state: 'success'});

        })
        .catch(e => {
          setRpcState({state: 'error', message: e});
        })
  }, []);

  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={'Clients'} tabs={useClientsTab()}/>

    <div className={'ProviderToolAreaContent'}>

      {/* TODO how to handle versioning on providers */}
      <KensuTable data={clients}
                  onRowSelected={r => navigate('./' + r?.user?.userId)} columns={[
        {label: 'Name', render: row => fullName(row?.user), sortString: row => row?.user?.familyName},
        {label: 'Since', render: row => shortDateFormat(new Date(row.relationship?.createdTimestampMs as number)), sortOrder: row => row.relationship?.createdTimestampMs},
      ]}/>

      {rpcState.state == 'pending' && 'Loading...'}
      {rpcState.state == 'error' && <div className={'ErrorText'}>Error loading client list</div>}
      {rpcState.state == 'success' && !clients?.length && <div>
        <br/><br/>
        Once a client schedules an appointment they'll be listed here.
      </div>}

    </div>
  </div>

};

